// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@200&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message {
    position: fixed;
    bottom: 7%;
    left: 45%;
    background: #212121;
    border-radius: 7px;
    width: 100px;
    border: 7px solid #212121;
}

.message h1 {
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    margin: auto;
    color: #FFFFFF;
}

@media screen and (max-width: 600px) {
    .message {
        left: 16%;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/css/ConfirmMessage.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI;QACI,SAAS;IACb;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200&display=swap');\n\n.message {\n    position: fixed;\n    bottom: 7%;\n    left: 45%;\n    background: #212121;\n    border-radius: 7px;\n    width: 100px;\n    border: 7px solid #212121;\n}\n\n.message h1 {\n    font-family: Nunito;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n    margin: auto;\n    color: #FFFFFF;\n}\n\n@media screen and (max-width: 600px) {\n    .message {\n        left: 16%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
